import * as Yup from "yup";

export const contactSchema = Yup.object().shape({
  reason: Yup.string().trim().default(''),
  description: Yup.string().trim().default(''),
  file_uploaded: Yup.array().of(
    Yup.object().shape({
      url: Yup.string().trim().default(''),
    })
  ).default([]),
  is_resolved: Yup.boolean().default(false),
});
